import { Button, Checkbox } from 'flowbite-react'
import React, { useEffect, useState } from 'react'
import CustomTable from '../../../../components/Table/CustomTable'
import client from '../../../../api/client'
import CustomModal from '../../../../components/Modal/CustomModal'
import AddNewAccount from './AddNewAccount/AddNewAccount'
import { PayoutsDataNew,ColumnPayoutsNew } from '../../../../types/TablesTypes/Payouts'
import showToast from '../../../../components/CustomToast/toastHelper'

const PayoutAccount = () => {
    const [details, setDetails] = useState<string>("")
    const [openModal, setOpenModal] = useState(false)
    const [transactions, setTransactions] = useState<any>()
    const [tableRow, setTableRow] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(true);


    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)
            await getSettlementDetails()
            await getBankDetails()
            setLoading(false)
        }
        fetchData()
    }, [])

    const getBankDetails = async () => {
        try {
            const response = await client.get('/subsidiary/dashboard/settlement/bank/get');
            setTransactions(response.data);
            const message = response?.data?.message;

        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
            }
        }
    }

    const setSettlementDetails = async (type:string) => {
        let payload ={
            "settlementType":type
        }
        try {
            const response = await client.post('/subsidiary/dashboard/settlement/details', payload);
            const message = response?.data?.message;
            showToast(message, 'success')
            getSettlementDetails()

        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
            }
        }
    }
    
    const getSettlementDetails = async () => {
        try {
            const response = await client.get('/subsidiary/dashboard/settlement/details/get');

            setDetails(response.data.data);
            const message = response?.data?.message;

        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
            }
        }
    }

    const dataPayout = () => {
		const tempArr: PayoutsDataNew[] = [];
		transactions?.data
			?.slice(0)
			.reverse()
			.forEach((payout: any, index: number) => {
				tempArr.push({
					bankName: payout.bankName,
					accountNumber: payout?.accountNumber,
					accountName: payout?.accountName,
				});
			});
		return tempArr;
	};

    useEffect(() => {
		setTableRow(dataPayout());
	}, [transactions?.data]);
    return (
        <div>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-8 h-full'>
                <div className='flex flex-col h-full mt-20'>
                    <p className='text-3xl font-semibold'>Accounts</p>
                    <p className='text-sm'>Which account would you like to get your earnings?</p>
                </div>
                <div className='h-full'>
                    <Button className='ml-auto bg-green-800' onClick={()=>setOpenModal(true)}>Add a bank account</Button>
                    <div className='my-10'>
                        <div className='flex items-center gap-4 my-4'>
                            <Checkbox checked={details =="wallet"} onClick={()=>setSettlementDetails("wallet")}/>
                            <p className='text-sm'>Settle to Ideospay account</p>
                        </div>
                        <hr/>
                        <div className='flex items-center gap-4 my-4'>
                            <Checkbox checked={details =="bank"} onClick={()=>setSettlementDetails("bank")}/>
                            <p className='text-sm'>Settle to Bank</p>
                        </div>
                    </div>
                    <div className='w-full my-4 flex justify-between'>
                        <div></div>
                        <div className='flex gap-4'>
                            <button className='border px-6 py-4 rounded-lg text-md font-semibold'>Cancel</button>
                            <button className='border px-6 py-4 rounded-lg bg-custom-button-green text-md font-semibold'>Save changes</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className='my-20'>
                <CustomTable data={ tableRow ? tableRow : []} loading={loading} headings={ColumnPayoutsNew} emptyMessage='You currently do not have any payout accounts'/>
            </div>
            <CustomModal children={<AddNewAccount close={()=>setOpenModal(false)} refreshPage={()=>getBankDetails()}/>} dismissible={true} show={openModal} icon='' onClose={()=>setOpenModal(false)} size='lg'/>

        </div>
    )
}

export default PayoutAccount
